<nav class="nav-bar">
  <p-menubar [model]="navbarMenu">
  </p-menubar>
</nav>